<template>
  <div class="app">
	<div>
		<div class="nav">
			<div>
				<h3>{{list.name}}</h3>
				<p>{{list.ygzdw}}</p>
				<p>{{list.zw}}</p>
			</div>
			<div>
				<img :src="list.user" alt="">
			</div>
		</div>
		<div class="bq">
			<div class="bq_title">
				<img src="@assets/images/banner/nav_1.png" alt="">
				<h3>个人标签</h3>
			</div>
			<div class="">
				<span>{{list.zzmm_dictText}}</span>
				<span v-if="list.zyly_dictText">{{list.zyly_dictText}}</span>
				<span v-if="list.byyx">{{list.byyx}}</span>
			</div>
		</div>
	</div>
	<div class="nr">
		<div class="bq bq2">
			<div class="bq_title">
				<img src="@assets/images/banner/nav_1.png" alt="">
				<h3>个人简介</h3>
			</div>
			<div class="bq-content">
				<p>{{list.rcjj}}</p>
			</div>
		</div>
		<div class="btn" @click="goPage">
			<p>立即沟通</p>
		</div>
	</div>
  </div>
</template>

<script>
import{getAction} from "@/api/manage"
  export default {
    data(){
		return{
			id:'',
			list:{}
		}
	},
	mounted() {
		this.id = this.$route.params.id || sessionStorage.getItem('zjzxId')
		this.init()
	},
	methods:{
		init(){
			let params = {id:""}
			params.id = this.id
			console.log("id",params.id);
			getAction("/zhshj/rclmrczj/query/list/by/id",params).then(res=>{
				console.log("res详情",res);
				if(res.code==200){
					this.list = res.result[0]
					if(this.list.imgUrl){
						this.list.user = this.list.imgUrl.split(',')[0]
					}else{
						this.list.user = require("@images/banner/user.jpg")
					}
				}
				console.log("list",this.list);
			})
		},
		goPage(){
			this.$router.push({
				name:"zyzx_ly",
				params:{
					type:1,
					id:this.id
				}
			})
		}
	}
  }
</script>

<style scoped lang="less">
.app{
	width: 100%;
	min-height: 100vh;
	background: #f5f5f5;
}
h3,p{
	margin: 0px;
}
.nav{
	width: 100%;
	background: white;
	display: flex;
	padding: 20px 14px 20px 10px;
	box-sizing: border-box;
	margin: 0px 0px 20px;
	justify-content: space-between;
	>div:first-child{
		h3{
			font-size: 16px;
		}
		p{
			color: #666666;
			font-size: 14px;
			margin: 6px 0px;
		}
	}
	>div:last-child{
		img{
			height: 80px;
			border-radius: 4px;
		}
	}
}
.bq{
	padding: 20px 14px 20px 20px;
	background: white;
	margin: 0px 0px 20px;
	.bq_title{
		position: relative;
		margin: 0px 0px 10px;
		img{
			width: 8px;
			position: absolute;
			top: 3px;
			left: -10px;
		}
	}
	>div{
		h3{
			font-size: 16px
		}
		span{
			padding: 2px 4px;
			color: #999999;
			background: #F3F3F4;
			border-radius: 4px;
			font-size: 14px;
			display: inline-block;
			margin: 0px 8px 8px 0px;
		}
	}
	&-content{
		height: 100%;
		overflow: hidden;
		overflow-y: auto;
		box-sizing: border-box;
		padding-bottom: 10px;
		p{
			font-size: 14px;
			text-indent: 2em;
			line-height: 20px;
			letter-spacing: 0.5px;
		}
	}
}
.bq2{
	height: 300px;
	overflow: hidden;
	margin: 0px;
}
.nr{
	width: 100%;
	height: 60vh;
	margin: 0px;
	padding: 0px;
}
.btn{
	width: 100%;
	height: 50px;
	background: #4C71E3;
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	p{
		margin: 0px;
		padding: 0px;
	}
}
</style>